import React, { useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import useApi from '../../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import { useInvoiceInfo } from '../InvoiceInfoProvider';

function ModalUpdatePaymentInfo() {
    const { invoiceInfo, handleReload } = useInvoiceInfo();
    const [loading, setLoading] = useState(false);
    const paymentInstructionList = invoiceInfo?.invPaymentList || [];
    const { setMessage, closeModal } = useTemplate();
    const { put } = useApi();
    const [formData, setFormData] = useState({
        PaymentId:
            invoiceInfo?.invoice?.paymentInfoId ||
            paymentInstructionList.find((item) => item.isDefault)?.id ||
            0
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name) {
            setFormData((prevData) => ({ ...prevData, [name]: value }));
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        put(`/api/invoices/${invoiceInfo?.invoice?.id}/update-payment-instruction`, {
            InvoiceId: invoiceInfo?.invoice?.id,
            PaymentInstructionId: Number(formData.PaymentId || 0)
        })
            .then(({ error, message }) => {
                if (error) {
                    throw new Error(message);
                }
                setMessage({ type: 'success', text: message });
                handleReload();
                closeModal();
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err.message });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-3 mb-5">
                {paymentInstructionList.length === 0 && (
                    <p className="text-invoice-secondary text-sm">
                        No payment instructions available.
                    </p>
                )}

                {paymentInstructionList.map((instruction) => (
                    <label
                        key={instruction.id}
                        className="flex items-center bg-primary-50 p-3 rounded-10 cursor-pointer hover:bg-primary-100"
                    >
                        <input
                            type="radio"
                            name="PaymentId"
                            value={instruction.id}
                            checked={Number(formData.PaymentId) === instruction.id}
                            onChange={handleChange}
                            className="mr-2"
                        />
                        <div
                            className="text-sm"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                                __html: instruction.text.replace(/\n/g, '<br>')
                            }}
                        />
                    </label>
                ))}
            </div>
            <div className="flex justify-end">
                <div className="flex items-center gap-x-3">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Save" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default ModalUpdatePaymentInfo;
